"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Identity = void 0;
var _cookie = require("../../utils/cookie");
var _analyticsState = require("./analytics-state");
var _cohort = require("./cohort");
var _helpers = require("./helpers");
var _tracking = require("./tracking");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var TRELLO_USER_ID = 'token';
var XID = 'seg_xid';
var pageViewProperties = {};
// cookie used by Marketo to track interactions, allows a website to link visitor behavior across sites and campaigns
var MARKETO_ID = '_mkto_trk';
var REFERRER_TRELLO_DOMAINS = ['trello.com', 'trellis.coffee'];
var Identity = exports.Identity = /*#__PURE__*/function () {
  function Identity() {
    _classCallCheck(this, Identity);
  }
  return _createClass(Identity, null, [{
    key: "identify",
    value:
    /**
     * Sends a track event with known identifiers
     * @function identify
     * @param {string} userId - required
     * @param {object} traits - optional, dictionary of custom traits to send
     */
    function identify(userId, traits) {
      traits = !!traits && _typeof(traits) === 'object' ? traits : {};
      var data = traits;
      data['atlassian_id'] = userId;
      data['atlJSVersion'] = _analyticsState.AnalyticsState.version || '1.0.0';
      try {
        data['ga_clientid'] = _cookie.Cookie.readCookie('_ga');
      } catch (e) {
        _helpers.Helpers.sendWrapperLoadError('Error reading _ga cookie');
      }
      _tracking.Tracking.trackEvent('known_identifiers', data);
    }

    /**
     * used internally to gather all known ids and call identify
     * @function autoIdentify
     */
  }, {
    key: "autoIdentify",
    value: function autoIdentify() {
      var emailDetected = _helpers.Helpers.emailAddressIsDetected();
      var userId = Identity.getAtlassianUserId();
      var xid = _cookie.Cookie.readCookie(XID);
      if (emailDetected) {
        var integrations = {
          All: false,
          'Google Analytics': true
        };
        if (!_analyticsState.AnalyticsState.pageViewOptions) {
          _analyticsState.AnalyticsState.pageViewOptions = {
            integrations: integrations
          };
        } else {
          _analyticsState.AnalyticsState.pageViewOptions['integrations'] = integrations;
        }
        if (_helpers.Helpers.urlContainsEmail(window.location.href)) {
          _helpers.Helpers.addCleanedUrlAndPaths(pageViewProperties);
        }
        if (_helpers.Helpers.urlContainsEmail(document.referrer)) {
          _helpers.Helpers.addCleanedReferrer(pageViewProperties);
        }
      }
      try {
        pageViewProperties['anonymous_id'] = _analyticsState.AnalyticsState.anonymousId;
      } catch (e) {
        _helpers.Helpers.sendWrapperLoadError('Error reading segment anonymousId');
      }
      try {
        pageViewProperties[_cohort.ATL_COHORT] = _cohort.Cohort.readWriteAtlCohort();
      } catch (e) {
        _helpers.Helpers.sendWrapperLoadError('Error read / writing atlCohort cookie');
      }
      if (userId || xid) {
        Identity.identify(userId, pageViewProperties);
      }
    }
  }, {
    key: "getAtlassianUserId",
    value: function getAtlassianUserId() {
      var userId = _cookie.Cookie.readCookie('__aid_user_id');
      if (userId) {
        return decodeURIComponent(userId);
      }
      return null;
    }
  }, {
    key: "getTrelloUserId",
    value: function getTrelloUserId() {
      try {
        var page = location.href ? new URL(location.href) : null;
        // since the trello cookie is such a common name. check to make sure we're actually on a trello page
        if (page && (page.hostname.includes('trello.com') || page.hostname.includes('trellis.coffee'))) {
          var token = _cookie.Cookie.readCookie(TRELLO_USER_ID);
          if (token) {
            return decodeURIComponent(token).split('/')[0];
          }
        }
      } catch (e) {
        _helpers.Helpers.sendWrapperLoadError('Error reading Trello userId');
      }
      return null;
    }
  }, {
    key: "getMarketoId",
    value: function getMarketoId() {
      var marketoId = _cookie.Cookie.readCookie(MARKETO_ID);
      if (marketoId) {
        return decodeURIComponent(marketoId);
      }
      return null;
    }
  }, {
    key: "getMarketoIdPromise",
    value: function getMarketoIdPromise() {
      var enableRetry = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var waitCount = 0;
      var maxWait = enableRetry ? 5000 : 0;
      return new Promise(function (resolve) {
        Identity._internalMarketoPromise(waitCount, maxWait, resolve);
      });
    }
  }, {
    key: "_internalMarketoPromise",
    value: function _internalMarketoPromise(waitCount, maxWait, resolve) {
      var delay = 500;
      var marketoId = _cookie.Cookie.readCookie(MARKETO_ID);

      // wait for up to 5 seconds for the marketo cookie to show up
      if (marketoId) {
        resolve(decodeURIComponent(marketoId));
      } else {
        waitCount += delay;
        if (waitCount >= maxWait) {
          _helpers.Helpers.sendWrapperLoadError('getMarketoIdPromise error');
          resolve('');
        } else {
          if (typeof setTimeout === 'function') {
            setTimeout(function () {
              Identity._internalMarketoPromise(waitCount, maxWait, resolve);
            }, delay);
          } else {
            // handle the case where setTimeout is not a function
            _helpers.Helpers.sendWrapperLoadError('getMarketoIdPromise error - setTimeout is not a function');
            resolve('');
          }
        }
      }
    }
  }, {
    key: "isReferrerTrello",
    value: function isReferrerTrello() {
      if (!document.referrer) {
        return false;
      }
      var ref = new URL(document.referrer);
      return REFERRER_TRELLO_DOMAINS.includes(ref.hostname);
    }
  }]);
}();